import { useEffect, useState } from "react";

const NAV = [
    { id: "for-you", label: "Кому полезна" },
    { id: "packages", label: "Форматы" },
    { id: "results", label: "Результат" },
    { id: "about", label: "Обо мне" },
    { id: "contact", label: "Контакты" },
];

export const Header = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const threshold = () => Math.max(window.innerHeight - 120, 600);
        const onScroll = () => setScrolled(window.scrollY > threshold());
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        window.addEventListener("resize", onScroll);
        return () => {
            window.removeEventListener("scroll", onScroll);
            window.removeEventListener("resize", onScroll);
        };
    }, []);

    const handleNav = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const onHero = !scrolled;
    const fg = onHero ? "#F4F1EA" : "#1B2A41";
    const fgMuted = onHero ? "rgba(244,241,234,0.8)" : "rgba(27,42,65,0.75)";
    const border = onHero ? "rgba(244,241,234,0.18)" : "rgba(27,42,65,0.12)";
    const bg = onHero ? "transparent" : "rgba(244,241,234,0.9)";

    // Full "Vnutri" wordmark — terracotta over the dark hero, indigo on the parchment scroll state.
    const logoSrc = onHero ? "/img/logo-terracotta.svg" : "/img/logo-indigo.svg";

    return (
        <header
            data-testid="site-header"
            style={{
                backgroundColor: bg,
                borderBottom: `1px solid ${border}`,
                backdropFilter: onHero ? "none" : "blur(16px)",
                WebkitBackdropFilter: onHero ? "none" : "blur(16px)",
            }}
            className="fixed top-0 left-0 right-0 z-50 transition-colors duration-500"
        >
            <div className="max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16 h-20 flex items-center justify-between">
                <button
                    data-testid="brand-logo"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                    aria-label="Внутри · IT consultancy"
                    className="flex items-center gap-3 group"
                >
                    <img
                        src={logoSrc}
                        alt="Внутри · IT consultancy"
                        data-testid="brand-logo-img"
                        className="h-7 sm:h-8 w-auto block object-contain transition-opacity duration-500"
                        draggable="false"
                    />
                </button>

                <nav className="hidden lg:flex items-center gap-10">
                    {NAV.map((item) => (
                        <button
                            key={item.id}
                            data-testid={`nav-${item.id}`}
                            onClick={() => handleNav(item.id)}
                            className="text-sm tracking-wide vnutri-link transition-colors hover:!opacity-100"
                            style={{ color: fgMuted }}
                        >
                            {item.label}
                        </button>
                    ))}
                </nav>

                <a
                    data-testid="header-telegram-cta"
                    href="https://t.me/ekulakova1"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hidden sm:inline-flex items-center gap-2 px-5 py-2.5 text-xs tracking-[0.2em] uppercase font-semibold transition-colors"
                    style={{
                        backgroundColor: onHero ? "#C46342" : "#1B2A41",
                        color: "#F4F1EA",
                    }}
                >
                    Telegram
                    <span style={{ color: onHero ? "#F4F1EA" : "#C46342" }}>→</span>
                </a>
            </div>

            {/* Hidden helper to keep `fg` referenced (for future use); not rendered visibly. */}
            <span aria-hidden="true" style={{ display: "none", color: fg }} />
        </header>
    );
};
